import { render, staticRenderFns } from "./PlaceUnitList.vue?vue&type=template&id=4e97ab86"
import script from "./PlaceUnitList.vue?vue&type=script&lang=js"
export * from "./PlaceUnitList.vue?vue&type=script&lang=js"
import style0 from "./PlaceUnitList.vue?vue&type=style&index=0&id=4e97ab86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports